import styled from 'styled-components';
import Typography from 'components/elements/Typography';

export const Header = styled.header<{ $size: string }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  /* margin-bottom: ${({ theme }) => theme.spacing(3)}; */
  width: ${({ $size }) => $size};
`;
export const ContainerMainText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 13px;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
`;

export const UserAndTitle = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  padding-left: 40px;
`;

export const LogoConfiguraChristmas = styled.img``;

export const LogoConfigura = styled(Typography)`
  color: #1c1c1c;
  font-family: 'Globotipo Regular';
  font-size: 1.25rem;
  font-weight: 400;
`;

export const Title = styled(Typography)`
  font-weight: 400;
  text-overflow: ellipsis;
  font-size: 24px;
`;

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.grey[200]};

  font-weight: 400;
`;

export const Logo = styled.img``;
export const Line = styled.div`
  width: 1px;
  height: 100%;
  background-color: #1c1c1c;
`;

export const Group = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 24px;
`;
